<!-- <span><strong>{{ socketViewers }}</strong> socketviewers </span> | -->
<span><strong>{{ viewers }}</strong> {{ 'REALTIME_VIEWERS' | translate }}</span> &nbsp;&nbsp;&nbsp;
<small class="mobile-viewers"><i class="fa fa-mobile"></i>&nbsp;&nbsp;<strong>{{ mobileViewers }}</strong> {{ 'REALTIME_MOBILE_VIEWERS' | translate }}</small>
